<template>
  <bm-unit-base
    v-bind="$attrs"
    :value="value"
    :unit-preference="unitPreference"
    @update:value="emit('update:value', $event)"
  />
</template>

<script setup lang="ts">
import { tenantService } from "@/app/services/extensions/tenantServiceExtended";
import BmUnitBase from "@/components/controls/input/specialised/BmUnitBase.vue";

interface BmWeightProps {
  value?: number | null;
}

interface BmWeightEvents {
  (event: "update:value", value: number | null): void;
}

withDefaults(defineProps<BmWeightProps>(), {
  value: null,
});

const emit = defineEmits<BmWeightEvents>();

const unitPreference =
  tenantService.settings.displayUnitPreferences.generalWeights;
</script>
